(function ($) {
    $('[data-term-id]').on("click", function(){
        // Get the value of the 'data-term-id' attribute
        const termId = $(this).data('term-id');

        // Check if an element with id equal to 'termId' exists
        if($('#' + termId).length > 0) {
            // Remove 'active-category-link' class from all elements with class 'active-category-link'
            $('.project-term-link-wrap').removeClass('active-category-link');

            // Add 'active-category-link' class to element with id equal to 'termId'
            $('#' + termId).addClass('active-category-link');
        } else  {
            $('.project-term-link-wrap').removeClass('active-category-link');
        }
    });
})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/section-portfolio_of_projects.es6